export default {"src":"/_next/static/image/public/images/flags/flag_243.cf4b9a4a0b78411606a4e99221e4517f.svg","height":16,"width":24};